import { createBrowserHistory } from "history";
import configureStore from "./_reducers/configureStore";

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
export const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const initialStore = configureStore(history, initialState);

export const store = initialStore;
